<script setup lang="ts">
import {computed, defineProps, ref, defineEmits, watch} from "vue";
import PrimeDropdown from "@/components/forms/dropdown/themed/PrimeDropdown.vue";
import {useRequest} from "vue-request";
import {
  fetchEpayIndiaBanks, fetchEpayIndonesiaBanks,
} from "capitalist-shared/src/finance/epay/epay";

const props = defineProps({
  value: {
    type: String,
    required: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  country: {
    type: String,
    default: 'india'
  }
})

const config = {
  india: {
    url: '/webapi/finance/epy/indiaBanks',
    fetcher: fetchEpayIndiaBanks
  },
  indonesia: {
    url: '/webapi/finance/epy/indonesiaBanks',
    fetcher: fetchEpayIndonesiaBanks
  }
}

const activeConfig = computed(() => {
  return config[props.country] || config.india;
})

const pagesize = ref(300);
const page = ref(0);
const search = ref('');

const bankListData = useRequest(() => activeConfig.value.fetcher(search.value, page.value, pagesize.value), {
  cacheKey: () => {
    return [activeConfig.value.url, page.value, search.value, pagesize.value].join('-');
  },
  refreshDeps: [search, page, pagesize],
  cacheTime: 600000,
  errorRetryCount: 6,
  errorRetryInterval: 3000,
  // pollingInterval: 600000,
  debounceInterval: 300,
})

const emits = defineEmits(['input', 'selected'])

const isSelectDisabled = computed(() => {
  return props.disabled || bankListData.loading?.value;
})

const options = computed(() => {
  return (bankListData.data.value?.banks || []).map((option, idx) => {
    return {
      ...option,
      keyIdx: [idx, option.bankId, option.locationId, option.bankName].join('-'),
    }
  });
})

const val = computed({
  get: () => props.value,
  set: (value) => emits('input', value)
})

const selectedOption = computed(() => {
  if (!val.value) return null;
  return options.value.find((option) => option.locationId === val.value);
})

watch(selectedOption, (v) => {
  emits('selected', v)
})
</script>

<template>
  <PrimeDropdown :filter="true" :filterPlaceholder="$t('Поиск...')"
                 :emptyFilterMessage="$t('Ничего не найдено')"
                 optionLabel="bankName"
                 optionValue="bankId"
                 :disabled="isSelectDisabled"
                 dataKey="keyIdx"
                 :placeholder="$t('Выберите банк...')"
                 :options="options"
                 v-model="val">
  </PrimeDropdown>
</template>

<style scoped lang="less">

</style>

<i18n src="capitalist-shared/src/finance/locales/ru/payout.json" locale="ru"></i18n>
<i18n src="capitalist-shared/src/finance/locales/en/payout.json" locale="en"></i18n>
